import React, { PureComponent } from "react";
import { UISref } from "@uirouter/react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { Icon } from "../../Common/Icon";
import { addNotificationReadFlag, hasNewNotifications } from "../../../helpers/notificationHelpers";
import { checkIsExternalUser } from "../../../helpers/Authorization/authorizationHelpers";
import { getNotificationsSelector } from "../../../selectors/selectors";
import MobileNavigationDecoration from "../../../assets/mobile-navigation-decoration.svg";

class MobileNavigation extends PureComponent {
  static propTypes = {
    currentPage: PropTypes.string,
    notifications: PropTypes.array
  };

  static defaultProps = {
    currentPage: "",
    notifications: []
  };

  state = {
    hasNewNotification: false,
    isListPageOpen: false,
    isNotificationListOpen: false,
    isOrderPageOpen: false,
    isOtherPageOpen: false,
    isPurchaseOrderListPageOpen: false
  };

  componentDidMount() {
    if (this.props.currentPage === "notification-list" || this.props.currentPage === "notification__panel") {
      this.handleOpenNotificationList();
    } else {
      this.handleCloseNotificationList();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEmpty(this.props.notifications)) {
      const newNotifications = hasNewNotifications(this.props.notifications);
      this.handleSetNewNotification(newNotifications);
    }

    if (!prevState.hasNewNotification && this.state.hasNewNotification) {
      toast(i18n.t("notification.newNotification"), { type: toast.TYPE.INFO });
    }

    window.onpopstate = setTimeout(() => {
      if (this.state.isNotificationListOpen && this.props.currentPage !== "notification-list" && this.props.currentPage !== "notification__panel") {
        this.handleCloseNotificationList();
      }
    }, 10);

    if (!this.state.isNotificationListOpen) {
      this.handleCloseNotificationList();
    }
  }

  handleSetNewNotification = hasNewNotification => this.setState({ hasNewNotification });

  handleOpenNotificationList = () => {
    this.setState({
      hasNewNotification: false,
      isListPageOpen: false,
      isPurchaseOrderListPageOpen: false,
      isOrderPageOpen: false,
      isOtherPageOpen: false,
      isNotificationListOpen: true
    });
    addNotificationReadFlag(this.props.notifications);
  };

  handleCloseNotificationList = () => {
    this.setState({ isNotificationListOpen: false });
    if (this.props.currentPage === "list-page") {
      this.setState({
        isListPageOpen: true,
        isPurchaseOrderListPageOpen: false,
        isOrderPageOpen: false,
        isOtherPageOpen: false
      });
    } else if (this.props.currentPage === "purchase-order-list-page") {
      this.setState({
        isListPageOpen: false,
        isPurchaseOrderListPageOpen: true,
        isOrderPageOpen: false,
        isOtherPageOpen: false
      });
    } else if (this.props.currentPage === "order-page") {
      this.setState({
        isPurchaseOrderListPageOpen: false,
        isOrderPageOpen: true
      });
    } else if (this.props.currentPage === "details-page" || this.props.currentPage === "grid-page") {
      this.setState({
        isOrderPageOpen: false,
        isOtherPageOpen: true
      });
    } else {
      this.setState({
        isListPageOpen: false,
        isNotificationListOpen: false,
        isOrderPageOpen: false,
        isOtherPageOpen: false,
        isPurchaseOrderListPageOpen: false
      });
    }
  };

  handleBackClick = () => {
    window.history.back();
  };

  render() {
    const { isListPageOpen, isPurchaseOrderListPageOpen, isOrderPageOpen, isOtherPageOpen, isNotificationListOpen } = this.state;
    const isExternal = checkIsExternalUser();

    return (
      <div role="navigation" className={classNames("mobile-navigation", isNotificationListOpen ? "notification-list" : this.props.currentPage)}>
        <img src={MobileNavigationDecoration} alt="" className="mobile-navigation__decoration" />

        <UISref to="home">
          <button
            className={classNames("mobile-navigation__icon", isListPageOpen && "--active", isExternal && "--inactive")}
            onClick={this.handleCloseNotificationList}
            disabled={isExternal}>
            <Icon id="customers" />
          </button>
        </UISref>

        <button
          className={classNames(
            "mobile-navigation__icon",
            isPurchaseOrderListPageOpen && "--active",
            !isPurchaseOrderListPageOpen && !isOrderPageOpen && "--inactive"
          )}
          onClick={isOrderPageOpen ? this.handleBackClick : undefined}>
          <Icon id="orders" />
        </button>

        <button className={classNames("mobile-navigation__icon", isOrderPageOpen || isOtherPageOpen ? "--active" : "--inactive")}>
          <Icon id="order" />
        </button>

        <UISref to="notification-list">
          <button
            className={classNames(
              "mobile-navigation__icon",
              (isNotificationListOpen || this.props.currentPage === "notification-list") && "--active"
            )}
            onClick={this.handleOpenNotificationList}>
            <Icon id="bell-mobile" className={classNames("notification-bell-mobile__icon", this.state.hasNewNotification && "--shake")} />
            {this.state.hasNewNotification && <figcaption className="notification-bell-mobile__indicator" />}
          </button>
        </UISref>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    notifications: getNotificationsSelector(state),
    userMetadata: state.app.userMetadata
  };
};

export default connect(
  mapStateToProps,
  {}
)(MobileNavigation);



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/MobileNavigation.js